export const getRoundedValueForMarketShare = (value: string) => {
  return Math.round(parseFloat(value) * 100);
};
